/**
 * Notiz beim Weiterleiten mitgeben (08.10.2026: „Notiz weiterleiten") — reine
 * Regeln, ohne React.
 *
 * Wer weiterleitet, schickt seine Notiz an die Durchwahl des Kollegen
 * (`POST telephony/uebergabe-notiz`). Beim Kollegen kommt sie als Ereignis
 * `uebergabe` an und wird dem passenden Anruf als Notiz-Entwurf vorangestellt:
 *  - direkt weitergeleitet: Der Anruf trägt die Nummer des Anrufers;
 *  - mit Rückfrage: Zuerst ruft der Absender selbst an — der Anruf trägt
 *    dessen Durchwahl.
 * Eine Übergabe wartet höchstens UEBERGABE_FRIST_MS auf ihren Anruf.
 */

export const UEBERGABE_FRIST_MS = 2 * 60 * 1000;

export interface OffeneUebergabe {
    anruferNummer: string | null;
    vonDurchwahl: string | null;
    vonName: string | null;
    notiz: string;
    seit: number;
}

function ziffern(n: string | null | undefined): string {
    return (n ?? "").replace(/\D/g, "");
}

/**
 * Gleiche Nummer trotz anderer Schreibweise (+49 171 … / 0171 …): ab sechs
 * Ziffern zählen die letzten neun, kürzere (Durchwahlen) müssen gleich sein.
 */
export function nummernGleich(a: string | null | undefined, b: string | null | undefined): boolean {
    const x = ziffern(a);
    const y = ziffern(b);
    if (!x || !y) return false;
    if (x.length < 6 || y.length < 6) return x === y;
    return x.slice(-9) === y.slice(-9);
}

/** Die passende offene Übergabe für einen Anruf mit `nummer` (die jüngste). */
export function passendeUebergabe(
    offen: readonly OffeneUebergabe[],
    nummer: string | null,
    jetzt: number,
): OffeneUebergabe | null {
    for (let i = offen.length - 1; i >= 0; i--) {
        const u = offen[i];
        if (jetzt - u.seit > UEBERGABE_FRIST_MS) continue;
        if (nummernGleich(u.anruferNummer, nummer) || nummernGleich(u.vonDurchwahl, nummer)) return u;
    }
    return null;
}

/** So steht die Übergabe im Notizfeld des Kollegen. */
export function uebergabeText(u: Pick<OffeneUebergabe, "vonName" | "vonDurchwahl" | "notiz">): string {
    const von = u.vonName?.trim() || (u.vonDurchwahl ? `Durchwahl ${u.vonDurchwahl}` : "Kollege");
    return `Notiz von ${von}: ${u.notiz.trim()}`;
}
